/**
 * Paints a single-colour SVG with CSS instead of rendering it through <img>.
 *
 * An <img> is opaque to CSS — its fills cannot be reached — which is why the
 * old design shipped a second `-active.svg` per icon with the colour baked in.
 * Masking makes the element's own background the icon colour, so the active
 * state can use the Dark/Primary/Main gradient and one asset serves both
 * states. `opacity` inside the file survives as mask alpha, so the duotone
 * icons keep their two tones.
 *
 * `isActive` is optional. Omit it where the icon has no active/inactive states
 * at all — a static list rather than navigation — and pass the colour through
 * `className` instead (Account does this: every row icon is Primary/Main).
 */
const NavIcon = ({
  src,
  isActive,
  className = "size-4",
}: {
  src: string;
  isActive?: boolean;
  className?: string;
}) => (
  <span
    aria-hidden="true"
    className={`icon-mask shrink-0 ${className} ${
      isActive === undefined
        ? ""
        : isActive
          ? "bg-dark-primary-gradient"
          : "bg-dark-text-100"
    }`}
    style={{ maskImage: `url(${src})`, WebkitMaskImage: `url(${src})` }}
  />
);

export default NavIcon;
